var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"govui-grid"},[(_vm.userHasLoaded)?_c('router-view'):_c('b-loading',{attrs:{"isFullPage":"","active":""}},[_c('CustomLoaderAnimation')],1),_c('GAInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }